<ng-container *cignaResponsive="let screen">
  <div
    class="row"
    [ngClass]="screen.isSmallerOrEqual('sm') ? 'pl-3 pr-3' : 'pl-4'"
  >
    <div class="col-sm-12">
      <ul>
        <li class="pt-12" *ngFor="let drug of ifpCopy">
          <small class="mr-t" [innerHTML]="drug.text"></small>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
